module.exports = __webpack_public_path__ + "static/media/Ocho_personas_que_parecían_mil.2746480d.jpg";